import { a as o_global } from "../chunks/common-namespaces-client-C7k75bsz.mjs";
import { o as otto } from "../chunks/common-nexus-client-MnzJr7CK.mjs";
const debugSync = o_global.debug ?? {};
const logger = debugSync.logger;
const scope = debugSync.scope;
const Level = debugSync.Level;
const status = debugSync.status;
const sendLog = (otto.apm ?? {}).sendCustomError;
export {
  Level,
  debugSync,
  logger,
  scope,
  sendLog,
  status
};
/*                                     */
